import { useWfAuthStore } from 'src/api/wf/stores/WfAuthStore';
import WF_Menu from '../../common/menu/WF_Menu';
import WF_Header from '../../common/header/WfHeader';

const WF_4_3_2_MainMenu = () => {
  const { authenticated } = useWfAuthStore();
  return (
    <div className=" flex flex-col">
      {authenticated && <WF_Header />}
      <WF_Menu typhoonInfo generalMenu />
    </div>
  );
};

export default WF_4_3_2_MainMenu;
